import { Button, type ButtonProps } from '@hivebrite/design-system/Button';
import {
  CATEGORIES,
  FontAwesomeIcon,
} from '@hivebrite/design-system/FontAwesomeIcon';

interface ButtonTriggerProps extends Omit<ButtonProps, 'onClick'> {
  onClick: () => void;
}

export const ButtonTrigger = ({ onClick, ...props }: ButtonTriggerProps) => (
  <Button
    variant="secondary"
    onClick={onClick}
    icon={() => (
      <FontAwesomeIcon
        iconName="sparkles"
        height="16px"
        iconType={CATEGORIES.SOLID}
      />
    )}
    {...props}
  >
    {s__('AIForm|Open AI assistant')}
  </Button>
);
